// extracted by mini-css-extract-plugin
module.exports = {"fixMenu":"NavbarMSubMeu_fixMenu__Y_l8_"};